import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Icon from '@material-ui/core/Icon';
import Fab from '@material-ui/core/Fab';

import Dialog from './sessionNewJoinDialog.component';

const styles = () => ({
  row: {
    textAlign: 'center',
    borderBottom: 'none',
  },
  btn: {
    margin: '10px',
  },
});

class sessionNewJoinButtonComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      open: false,
    };
  }

  handleClickOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  render() {
    const { classes, session } = this.props;

    return (
      <TableRow tabIndex={-1}>
        <TableCell colSpan={6} className={classes.row}>
          <Fab
            color="secondary"
            className={classes.btn}
            onClick={this.handleClickOpen}
            mini="true"
          >
            <Icon>add</Icon>
          </Fab>
          <Dialog session={session} closeDialog={this.handleClose} open={this.state.open} />
        </TableCell>
      </TableRow>
    );
  }
}

sessionNewJoinButtonComponent.propTypes = {
  session: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.number,
    lastModified: PropTypes.number,
    name: PropTypes.string,
    files: PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      lastModified: PropTypes.number,
      savedByUser: PropTypes.bool,
    }),
  }).isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(sessionNewJoinButtonComponent);
